/**
 * Re 1 confetti — lightweight canvas burst on form success.
 */
(function () {
  'use strict';

  function fireConfetti() {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
    document.body.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    if (!ctx) {
      canvas.remove();
      return;
    }

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resize();
    window.addEventListener('resize', resize, { once: true });

    const colors = ['#ff1493', '#ffd700', '#22c55e', '#4b0082', '#ffffff', '#f97316'];
    const originX = window.innerWidth * 0.5;
    const originY = window.innerHeight * 0.35;
    const particles = [];

    for (let i = 0; i < 140; i += 1) {
      const angle = Math.random() * Math.PI * 2;
      const speed = Math.random() * 7 + 4;
      particles.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 4,
        rot: Math.random() * 360,
        vr: (Math.random() - 0.5) * 12,
        w: Math.random() * 8 + 5,
        h: Math.random() * 6 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rect: Math.random() > 0.45,
      });
    }

    let frame = 0;
    const maxFrames = 200;

    function tick() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.18;
        p.vx *= 0.99;
        p.rot += p.vr;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rot * Math.PI) / 180);
        ctx.fillStyle = p.color;

        if (p.rect) {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();
      });

      frame += 1;
      if (frame < maxFrames) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
        window.removeEventListener('resize', resize);
      }
    }

    requestAnimationFrame(tick);
  }

  window.Re1Confetti = { fire: fireConfetti };
})();
